export const PROD_DIALOG_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productTypeId", "brandName", "productName", "description" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product Name ID"
        }, {
            "name" : "productTypeId",
            "title" : "Product Type ID"
        }, {
            "name" : "brandName",
            "title" : "Brand Name"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        }, {
            "name" : "description",
            "title" : "Description"
        } ],
        "formName" : "ListProductCategoryMembers",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ProductForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productCategoryId",
            "action" : "",
            "id" : "ListProductCategoryMembers_productCategoryId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product Name ID",
            "type" : "HYPERLINK",
            "target" : "EditProduct",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductCategoryMembers_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event" :  "edit",
            "formData":{
                "formName":"EditProductRest",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/products/product/${productId}"
            },
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_productTypeId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "brandName",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_brandName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_productName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_description",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        } ],
        "target" : ""

    }
]